/// <amd-module name="Core/Medius.Core.Web/Scripts/AdminPages/AdministrationFavouriteLink/General/hasCustomizedTranslationsDialogBinding"/>
import { utils} from "knockout";
import * as $ from "jquery";
import { registerBinding } from "Core/Medius.Core.Web/Scripts/Medius/knockout/utils";
import { getLabelTranslation } from "Core/Medius.Core.Web/Scripts/lib/globalization";

interface BindingParameters {
    notifyOpen: ko.Observable<boolean>;
    actionResult: ko.Observable<boolean | null>;
}

const binding = {
    init(element: HTMLElement, valueAccessor: ko.Observable<BindingParameters>) {
        const notifyOpenSub = valueAccessor().notifyOpen.subscribe(() => {
            $(element).data('kendoDialog').open();
        });

        const actionResultNotifier = valueAccessor().actionResult;
        
        $(element).kendoDialog({
            visible: false,
            closable: false,
            actions: [
                {
                    text: getLabelTranslation("#Core/cancel"),
                    action() {
                        actionResultNotifier(false);
                        return true;
                    }
                },
                {
                    primary: true,
                    text: getLabelTranslation("#Core/yes"),
                    action() {
                        actionResultNotifier(true);
                        return true;
                    }
                }
            ]
        });

        utils.domNodeDisposal.addDisposeCallback(element, () => {
            notifyOpenSub.dispose();
            $(element).data("kendoDialog").destroy();
        });
    }
}

export function register() {
    registerBinding("has-customized-translations-dialog", binding);
}
